<template>
  <section id="bottom">
    <ul>
      <li>
        <figcaption>Mountain Home Showroom</figcaption>
        <router-link tag="a" to="/showroom">
          <div class="container">
            <div class="item">
              <img src="../../public/img/icons/91MountainHomeRoad/featureOne.jpg" alt="featureOne" />
            </div>
          </div>
        </router-link>
      </li>
      <li>
        <figcaption>Dado Showroom</figcaption>
        <router-link tag="a" to="/showroomTwo">
          <div class="container">
            <div class="item">
              <img src="../../public/img/icons/dado1/showroomOne.jpg" alt="featureOne" />
            </div>
          </div>
        </router-link>
      </li>
      <li>
        <figcaption>Outdoor Showroom</figcaption>
       <router-link tag="a" to="/showroomThree">
          <div class="container">
            <div class="item">
              <img src="../../public/img/icons/outdoorProjects/feature3.jpg" alt="featureOne" />
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
export default {}
</script>

<style scoped>
#bottom ul {
  padding: 0;
}

#bottom li {
  position: relative;
  list-style-type: none;
  margin: 0 auto;
  text-align: center;
}

#bottom img {
  width: 50%;
  -webkit-transition: 0.6s ease;
  transition: 0.6s ease;
}

#bottom img:hover {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}

#bottom {
  position: relative;
  height: 60px;
  margin: 0 auto;
  background-color: #d3d4d8;
  padding-top: 50px;
  padding-bottom: 300px;
  bottom: 8px;
}

#bottom img {
  width: 100%;
}

#bottom ul {
  position: relative;
  margin: 0 auto;
  display: block;
}

#bottom li {
  width: 33.333%;
  float: left;
}

.container {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.item {
  position: relative;
  top: 0;
  left: 0;
}

figcaption {
  font-size: 1.2rem;
  font-weight: 600;
  padding-bottom: 10px;
}

@media screen and (max-width: 600px){
  #bottom li {
  width: 100%;
  clear:both;
}
}
</style>
